import posthog from "posthog-js";

type OnboardingEvent =
  | "onboarding_start"
  | "onboarding_step_view"
  | "onboarding_skip"
  | "onboarding_complete"
  | "onboarding_replay_start"
  | "onboarding_replay_end";

interface TrackOptions {
  oncePerSession?: boolean;
  sessionKey?: string;
}

interface BaseProps {
  tour?: string;
  stepIndex?: number | null;
  stepId?: string | null;
  path?: string;
  authStatus?: "authenticated" | "unauthenticated";
  userId?: string;
  reason?: "skip" | "complete";
  replay?: boolean;
}

function shouldSendOncePerSession(key?: string, oncePerSession?: boolean) {
  if (!oncePerSession || !key || typeof window === "undefined") {
    return true;
  }
  if (sessionStorage.getItem(key) === "1") {
    return false;
  }
  sessionStorage.setItem(key, "1");
  return true;
}

export function normalizeTourName(tour?: string) {
  if (!tour) return "unknown";
  return tour
    .replace(/Tour$/, "")
    .replace(/([a-z])([A-Z])/g, "$1_$2")
    .toLowerCase();
}

export function trackOnboardingEvent(
  event: OnboardingEvent,
  props: BaseProps,
  options?: TrackOptions,
) {
  if (typeof window === "undefined") return;
  if (!posthog?.capture) return;

  const path = props.path ?? window.location.pathname;
  const payload = {
    ...props,
    path,
  };

  if (!shouldSendOncePerSession(options?.sessionKey, options?.oncePerSession)) {
    return;
  }

  posthog.capture(event, payload);
}

export function isReplayActive() {
  if (typeof window === "undefined") return false;
  return sessionStorage.getItem("cfl:onboarding-replay-active") === "true";
}

export function setReplayActive(active: boolean) {
  if (typeof window === "undefined") return;
  if (active) {
    sessionStorage.setItem("cfl:onboarding-replay-active", "true");
  } else {
    sessionStorage.removeItem("cfl:onboarding-replay-active");
  }
}
